import clsx from 'clsx';
import './loading.css';

type LoadingProps = {
  className?: string;
  size?: number;
};

export function Loading({ className, size = 40 }: LoadingProps) {
  return (
    <svg
      className={clsx('cometchat-calls-loading-spinner', className)}
      style={{ width: size, height: size }}
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.4963 31.8337C14.3288 31.8337 12.2826 31.4184 10.3576 30.5878C8.43283 29.7573 6.752 28.6235 5.31505 27.1866C3.87811 25.7496 2.74436 24.0688 1.9138 22.1441C1.08325 20.2191 0.667969 18.1728 0.667969 16.0053C0.667969 13.8114 1.08408 11.7563 1.9163 9.83991C2.74852 7.92324 3.88158 6.2481 5.31547 4.81449C6.74908 3.3806 8.43019 2.24755 10.3588 1.41533C12.2874 0.583104 14.3349 0.166992 16.5013 0.166992C16.8555 0.166992 17.1523 0.286853 17.3917 0.526576C17.6314 0.766298 17.7513 1.06324 17.7513 1.41741C17.7513 1.77185 17.6314 2.06866 17.3917 2.30783C17.1523 2.54727 16.8555 2.66699 16.5013 2.66699C12.8069 2.66699 9.66102 3.9656 7.0638 6.56283C4.46658 9.16005 3.16797 12.3059 3.16797 16.0003C3.16797 19.6948 4.46658 22.8406 7.0638 25.4378C9.66102 28.035 12.8069 29.3337 16.5013 29.3337C20.1957 29.3337 23.3416 28.035 25.9388 25.4378C28.536 22.8406 29.8346 19.6948 29.8346 16.0003C29.8346 15.6456 29.9545 15.3487 30.1942 15.1095C30.4339 14.87 30.7309 14.7503 31.0851 14.7503C31.4395 14.7503 31.7363 14.8702 31.9755 15.1099C32.2149 15.3494 32.3346 15.6462 32.3346 16.0003C32.3346 18.1667 31.9185 20.2142 31.0863 22.1428C30.2541 24.0714 29.121 25.7525 27.6871 27.1862C26.2535 28.62 24.5784 29.7531 22.6617 30.5853C20.7453 31.4175 18.6902 31.8337 16.4963 31.8337Z"
        fill="white"
      />
    </svg>
  );
}
